module.exports = __webpack_public_path__ + "img/avatar4.b8a04143.png";